import useApi from "../../api/useApi";

const useStandProductService = (standId) => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'get',
      'user/stand/' + standId + '/products/' + id,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useStandProductService::userShow', error),
    )
  }

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/stand/' + standId + '/products',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useStandProductService::userShowCollection', error),
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/stand/' + standId + '/products/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useStandProductService::userStore', error),
      data,
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, id, data) => {
    return api(
      'post',
      'user/stand/' + standId + '/products/' + id + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useStandProductService::userUpdate', error),
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/stand/' + standId + '/products/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useStandProductService::userDelete', error),
    )
  }

  return {
    objectType: 'stand_product',
    userShow,
    userShowCollection,
    userStore,
    userUpdate,
    userDelete,
  }
}

export default useStandProductService
